// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1T8gM","alert":"SettungsInbox_alert__1iwfY"};